import React from 'react';
import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

export default function ChatInput({ value, onChange, onSubmit, disabled }) {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            if (!disabled && value.trim().length > 0) {
                onSubmit?.(value);
            }
        }
    };

    return (
        <Box component="form" onSubmit={(event) => event.preventDefault()} sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', px: 2, pb: 2 }}>
            <TextField
                fullWidth
                minRows={1}
                maxRows={4}
                multiline
                label="Nachricht an den Bot"
                placeholder="Frag nach offenen Rechnungen oder einem Report…"
                value={value}
                onChange={(event) => onChange?.(event.target.value)}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                size="small"
            />
            <Tooltip title="Senden">
                <span>
                    <IconButton
                        color="primary"
                        onClick={() => !disabled && value.trim().length > 0 && onSubmit?.(value)}
                        disabled={disabled || value.trim().length === 0}
                        aria-label="Nachricht senden"
                    >
                        <SendRoundedIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
}
